import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import * as yup from "yup";
import { useStyles } from "../../../../../shared/styles/useStyles";
import { AppState } from "../../../../../redux/reducers/rootReducer";
import { IContractingOffice } from "../../../../../redux/types/types";
import { startSetContractingOffice } from "../../../../../redux/actions/correspondenceActions";

function useMiaForm() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const intl = useIntl();

  const { contractingOffice } = useSelector(
    (state: AppState) => state.correspondence
  );

  const initialValues = {
    miaUrl: contractingOffice?.miaUrl ?? "",
  };

  const validationSchema = yup.object({
    miaUrl: yup
      .string()
      .required(`${intl.formatMessage({ id: "RequiredUrl" })}`),
  });

  const submit = async ({ miaUrl }: { miaUrl: string }) => {
    const contractingOfficeData: IContractingOffice = {
      ...contractingOffice,
      miaUrl: miaUrl,
    } as IContractingOffice;

    await dispatch(
      startSetContractingOffice(
        contractingOfficeData,
        "urlSuccessfully",
        "urlError"
      )
    );
  };

  return { classes, initialValues, submit, intl, validationSchema };
}

export default useMiaForm;
